import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { useEditorCb } from 'components/app/editor/_mediator/use-editor-cb';
import { setHotkeyPLayerTimeListener, setTimeBoundaryClip } from './timestamp.slice';

export const useTimestamp = () => {
  const { getPlayerRef } = useEditorCb();
  const { currentPlayerDuration } = useAppSelector((state) => state.timestamp);
  const activeMenuClip = useAppSelector((state) => state.editor.activeMenuClip);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!activeMenuClip) return;
    const player = getPlayerRef();
    if (!player) return;
    const currentTime = player.getCurrentTime();
    dispatch(setHotkeyPLayerTimeListener(currentTime));
  }, [activeMenuClip, currentPlayerDuration]);

  useEffect(() => {
    if (activeMenuClip) return;
    dispatch(setTimeBoundaryClip(null));
  }, [activeMenuClip]);
};
